import { render } from "./ProductsOfferedModal.vue?vue&type=template&id=e7f81fa8"
import script from "./ProductsOfferedModal.vue?vue&type=script&lang=js"
export * from "./ProductsOfferedModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__